import { FormattedMessage } from 'react-intl';

import { SubscriptionStatus, type AdminPricingSettings } from '@/modules/api/codegen';
import { useSubscriptionUpgradeModal } from '@/modules/saas-upgrade';
import { Heading, Pane } from '@/modules/ui';

import * as felaRules from './OrderInfo.rules';
import { OrderInfoContent } from './OrderInfoContent';

export interface OrderInfoProps {
    adminPricingSettings?: AdminPricingSettings;
}

export const OrderInfo = ({ adminPricingSettings }: OrderInfoProps) => {
    const { openUpgradeModal } = useSubscriptionUpgradeModal();

    const isFreeTier =
        !!adminPricingSettings?.subscription &&
        [SubscriptionStatus.free, SubscriptionStatus.trial].includes(adminPricingSettings.subscription);

    if (!adminPricingSettings || (!isFreeTier && !adminPricingSettings.pricing)) return null;

    return (
        <Pane
            data-testid='settings-order-info'
            extend={{
                container: felaRules.container,
            }}
        >
            <Heading variant='h3' color='foregroundsPrimary'>
                <FormattedMessage id='settings.order.type.title' />
            </Heading>
            <OrderInfoContent adminPricingSettings={adminPricingSettings} isFreeTier={isFreeTier} onUpgrade={openUpgradeModal} />
        </Pane>
    );
};
